let list = [
  {
    id: "all",
    name: {
      en: "All",
      zh: "全部"
    }
  },
  {
    id: "art",
    name: {
      en: "Art",
      zh: "艺术品"
    }
  },
  {
    id: "trading_cards",
    name: {
      en: "Trading Cards",
      zh: "收集卡牌"
    }
  },
  {
    id: "juggerdraw_v1",
    name: {
      en: "JuggerdrawV1",
      zh: ""
    }
  },
  {
    id: "juggerdraw_v2",
    name: {
      en: "JuggerdrawV2",
      zh: ""
    }
  },
  {
    id: "ThuggerDRAW",
    name: {
      en: "ThuggerDRAW",
      zh: ""
    }
  }
];

export default list